var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit-2__Action Type=Edit2, State=Enabled, Size=24",
    className: "edit-2__Action edit-2__Type=Edit2, edit-2__State=Enabled, edit-2__Size=24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "edit-2__Vector (Stroke)",
    fill: "#454F5B",
    d: "M20.25 5.567a1.818 1.818 0 0 0-3.103-1.285L5.032 16.395l-.964 3.536 3.535-.964L19.718 6.853c.34-.341.532-.804.532-1.286Zm1.5 0c0 .88-.35 1.724-.972 2.346L8.523 20.17a.75.75 0 0 1-.333.193l-4.993 1.362a.75.75 0 0 1-.92-.921l1.36-4.993a.75.75 0 0 1 .194-.333L16.087 3.222a3.318 3.318 0 0 1 5.663 2.345Z",
    className: "edit-2__Vector edit-2__(Stroke)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit2);
export default __webpack_public_path__ + "static/media/edit2.2650e32a017c48b220403ad210a23bab.svg";
export { ForwardRef as ReactComponent };